import { axiosInstance } from '@/shared/api/axios';
import { ToukiGroupRequestType, ToukiGroupResponseType } from '@/shared/types/api/api.toukiGroup';

export const getToukiGroup = async ({
  groupId,
}: ToukiGroupRequestType): Promise<ToukiGroupResponseType> => {
  const { data } = await axiosInstance.post<ToukiGroupResponseType>(`/touki/groups`, {
    groupId,
  });

  return data;
};
